export default function selectJiraAreLabelsLoading(state, { source }) {
  return state.integrations.thirdPartyData[source].labels.loading
}
